export function isWindows(): boolean {
  return navigator.userAgent.includes('Windows');
}
